/**
 * @packageDocumentation
 * @module      AuditLogType.ts
 * @description Encapsulates a type of audit log.
 * @copyright   Copyright (c) 2021 by Corindus Inc., a Siemens Healthineers Company. All rights reserved.
 */
/**
 * Describes what type of audit log we have.
 */
export default class AuditLogType {
    /**
     * Constructor for maintenance logs
     *
     * @param displayName  How the type should be displayed to the user. Example: "Robotic Network"
     * @param summaryHeader The text to put at the top of the summary column.
     * @param itemHeader The text to put at the top of the item's identifier.
     * @param initiatorHeader The text to put at the top of the column that shows who took the action.
     * @param urlKey The key that should be put in the URL when asking the Cloud API for logs of this type.
     * @param secondaryItemHeader The text to put at the top of the secondary item column, or undefined
     *                            if that column should not show.
     * @param successHeader The text to put at the top of the Success column, or undefined if that column should not show.
     */
    constructor(displayName, summaryHeader, itemHeader, initiatorHeader, urlKey, secondaryItemHeader, successHeader) {
        this.displayName = displayName;
        this.summaryHeader = summaryHeader;
        this.itemHeader = itemHeader;
        this.initiatorHeader = initiatorHeader;
        this.secondaryItemHeader = secondaryItemHeader;
        this.urlKey = urlKey;
        this.successHeader = successHeader;
    }
    /**
     * Tell whether this audit lot includes a secondary item.
     */
    get hasSecondaryItem() {
        return !!this.secondaryItemHeader;
    }
    /**
     * Tell whether this audit log includes a Success column.
     */
    get hasSuccess() {
        return !!this.successHeader;
    }
}
//# sourceMappingURL=AuditLogType.js.map